<template>
  <div class="fmg" :class="`fmg--${Math.min(urls.length, 4)}`">
    <div
      v-for="(url, i) in urls.slice(0, 4)"
      :key="i"
      class="fmg-cell"
      role="button"
      tabindex="0"
      @click="$emit('open', i)"
      @keydown.enter="$emit('open', i)"
      @keydown.space.prevent="$emit('open', i)"
    >
      <img :src="url" :alt="`Media ${i + 1}`" loading="lazy" />
      <div v-if="i === 3 && urls.length > 4" class="fmg-overlay">
        +{{ urls.length - 4 }}
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({ urls: { type: Array, required: true } })
defineEmits(['open'])
</script>

<style scoped>
.fmg { display: grid; gap: 3px; border-radius: 10px; overflow: hidden; margin-top: 6px; }
.fmg--1 { grid-template-columns: 1fr; }
.fmg--2, .fmg--3, .fmg--4 { grid-template-columns: 1fr 1fr; }
.fmg-cell { position: relative; aspect-ratio: 1; overflow: hidden; cursor: pointer; }
.fmg--1 .fmg-cell { aspect-ratio: 16/10; }
.fmg-cell img { width: 100%; height: 100%; object-fit: cover; display: block; }
.fmg-overlay {
  position: absolute; inset: 0;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; font-weight: 500;
}
</style>
